import { render } from "./ExpertReport.vue?vue&type=template&id=c5cb4942&scoped=true&ts=true"
import script from "./ExpertReport.vue?vue&type=script&lang=ts"
export * from "./ExpertReport.vue?vue&type=script&lang=ts"

import "./ExpertReport.vue?vue&type=style&index=0&id=c5cb4942&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5cb4942"]])

export default __exports__